export default "__VITE_ASSET__700e1667__"